import { LifebuoyIcon } from "@heroicons/react/24/outline";

import { Collapsible, Paragraph } from "@fronterahealth/frontera-ui-components";

export const Support: React.FC = () => {
  return (
    <div className="flex flex-col w-full items-center my-4 md:my-8">
      <div className="w-full max-w-2xl px-4 sm:px-6">
        <div className="flex flex-col items-center">
          <Paragraph className="text-xl! md:text-2xl!" size="large" colorType="primary" displayType="loud">
            How can we help?
          </Paragraph>
          <Paragraph size="medium">We're here to support you every step of the way</Paragraph>
        </div>

        <div className="flex flex-col items-center m-2 p-4 sm:m-4 sm:p-6 md:p-8 border rounded-lg border-limestone-100 bg-white">
          <div className="flex flex-col items-center">
            <div className="flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-green-200">
              <LifebuoyIcon className="w-5 sm:w-6 text-green-600" />
            </div>

            <div className="flex flex-col items-center mt-4 mb-4 md:mb-8">
              <Paragraph className="text-lg! md:text-xl!" colorType="primary" displayType="loud">
                Need help?
              </Paragraph>
              <Paragraph size="medium">
                Send our team a support request. We typically respond within 24 hours.
              </Paragraph>
            </div>

            <a
              href="https://t9vgj.share.hsforms.com/2pqFEq-68RIi5xoNoS0oqsA"
              className="inline-flex items-center justify-center rounded-full bg-interaction-primary px-3.5 py-2.5 text-sm leading-[22px] text-white hover:bg-interaction-primary-hover"
            >
              Submit a support request
            </a>
          </div>
        </div>

        <div className="flex flex-col max-w-2xl m-2 p-4 sm:m-4 sm:p-6 md:p-8 border rounded-lg border-limestone-100 bg-white">
          <Paragraph className="text-xl! md:text-2xl!" colorType="primary" displayType="loud">
            Common Questions
          </Paragraph>

          <div className="border rounded-md border-limestone-100 px-3 py-2 sm:px-4 sm:py-2 my-2">
            <Collapsible
              headerIsClickable={true}
              headerContent={
                <Paragraph size="small" colorType="primary" displayType="loud">
                  How do I claim my clinic?
                </Paragraph>
              }
              bodyContent={
                <div className="flex flex-col pt-2 min-w-0">
                  <Paragraph className="wrap-break-word!" size="small" colorType="primary">
                    Click “Claim your clinic” and fill out the verification form. Our team will review your request and
                    follow up within 1 business day to confirm ownership and finish setting up your clinic account. Once
                    you’re set up, you’ll be able to log in and view your leads.
                  </Paragraph>
                </div>
              }
            />
          </div>

          <div className="border rounded-md border-limestone-100 px-3 py-2 sm:px-4 sm:py-2 my-2">
            <Collapsible
              headerIsClickable={true}
              headerContent={
                <Paragraph size="small" colorType="primary" displayType="loud">
                  How much does it cost?
                </Paragraph>
              }
              bodyContent={
                <div className="flex flex-col pt-2 min-w-0">
                  <Paragraph className="wrap-break-word!" size="small" colorType="primary">
                    Frontera is completely free for clinics. There are no hidden fees, subscription costs, or charges
                    for leads.
                  </Paragraph>
                </div>
              }
            />
          </div>

          <div className="border rounded-md border-limestone-100 px-3 py-2 sm:px-4 sm:py-2 my-2">
            <Collapsible
              headerIsClickable={true}
              headerContent={
                <Paragraph size="small" colorType="primary" displayType="loud">
                  Can I edit my clinic information?
                </Paragraph>
              }
              bodyContent={
                <div className="flex flex-col pt-2 min-w-0">
                  <Paragraph className="wrap-break-word!" size="small" colorType="primary">
                    Yes! Once you've claimed your clinic, you can update all your information including services
                    offered, hours, insurance accepted, and more.
                  </Paragraph>
                </div>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
